import React, { useEffect, useState } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Col, Divider, Form, Input, message, Radio, Row } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import { useHistory, useLocation } from 'react-router-dom'
import { ErrorMessages, checkStatus, showText } from '../../helpers/textValidation'
import { LastFedralTableApiFunction, createLocomotive, getAllLocomotiveLease, getLocomotiveByID, updateLocomotive } from '../../Services/LocomotiveServices'
import { CaretLeftOutlined, ConsoleSqlOutlined, ContactsOutlined, EditOutlined, FileTextOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import LocmotiveLookupModal from '../../Components/Modals/LocmotiveLookupModal'
import NotesModal from '../../Components/Modals/NotesModal'
import ContractModal from '../../Components/Modals/ContactsLocomotive'
import LocomotiveLeaseModal from '../../Components/Modals/LocomotiveLeaseModal'
import moment from 'moment'
import roleManager from '../../Components/roles'
import { formatCurrency } from '../../helpers/currencyFormatter'
import HistoryModal from './Modal/histroyModal'
import DataSheetModal from './Modal/DataSheetModal'
import LastFedralTable from './Table.js/LastFedral Table'
import LastFedral from './Table.js/LastFedral Table'
import OpenWorkOrderModal from './Modal/OpenModalWorkOrder'
import InspectionModal from './Modal/InspectionModal'
import PageLayout from '../../Components/LayoutComponents/PageLayout'
import { useMemo } from 'react'

const LocomotiveEdit = () => {

    const history = useHistory()
    const [Data, setData] = useState({})
    const [openModal, setOpenModal] = useState(false)
    const [modalData, setModalData] = useState()
    const [contractModal, setContractModal] = useState(false)
    const [leaseModal, setLeaseModal] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [edit, setEdit] = useState(false)
    const [form] = Form.useForm()
    const { state, data } = useLocation()
    const stateData = state;
    const [notesModal, setNotesModal] = useState(false)
    const equipID = state?.equipID;
    const [inspectionModal, setInspectionModal] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [ModalOpenWork, setModalOpenWork] = useState()
    const [isModalEquipDataSheet, setIsModalEquipDataSheet] = useState(false);
    const [dataSourceLastFedral, setDataSourceLastFedral] = useState([]);

    const newEquip = state?.data?.id;

    const showModal = () => {
        setIsModalEquipDataSheet(true);
    };
    const handleOk = () => {
        setIsModalEquipDataSheet(false);
    };

    const handleCancel = () => {
        setIsModalEquipDataSheet(false);
    };


    const Fields = [
        {
            name: "Equipment Id",
            key: "EquipUID",
            type: "Text",
            required: true,
            edit: roleManager("locomotive", "lookupEdit", "equipID") ? true : false,
            visibility: true,

        },
        {
            name: "Model",
            key: "Loco_Model",
            type: "Text",
            required: true,
            visibility: true,
            edit: roleManager("locomotive", "lookupEdit", "equipID") ? true : false,


        },
        {
            name: "Horsepower",
            key: "Loco_HP",
            type: "Number",
            required: true,
            visibility: true,


        },
        {
            name: "Powered Axels",
            key: "Axles",
            type: "Number",
            required: true,
            visibility: true,

        },


        {
            name: "Equipment Type",
            key: "Unit_Type",
            type: "Text",
            required: true,
            visibility: true,

        },
        {
            name: "Year Built",
            key: "Mfr_Year",
            type: "Text",
            required: true,
            edit: roleManager("locomotive", "lookupEdit", "year_built") ? true : false,
            visibility: true,

        },
        {
            name: "FRA",
            key: "FRA",
            type: "Text",
            required: true,
            edit: roleManager("locomotive", "lookupEdit", "fra") ? true : false,
            visibility: true,

        },
        {
            name: "Location",
            key: "name",
            type: "Text",
            required: true,
            edit: roleManager("locomotive", "lookupEdit", "location") ? true : false,
            visibility: true,

        },

        {
            name: "Status",
            key: "status",
            type: "Text",
            required: true,
            edit: roleManager("locomotive", "lookupEdit", "status") ? true : false,
            visibility: true,

        },
        {
            name: "Lease/Financial",
            key: "lease",
            type: "Text",
            required: true,
            edit: roleManager("locomotive", "lookupEdit", "lease") ? true : false,
            visibility: roleManager("locomotive", "lookupEdit", "leaseView") ? true : false,
        },
        {
            name: "Accounting Job",
            key: "ActJob",
            type: "Text",
            required: true,
            edit: data || roleManager("locomotive", "lookupEdit", "accountingJob") ? true : false,
            visibility: true,

        },
    ]

    const LastFedralTableApi = async () => {
        try {
            const { data } = await LastFedralTableApiFunction(newEquip);
            setDataSourceLastFedral(data); // Set the value of dataSource directly
        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle the error if needed
        }
    };


    useEffect(() => {
        LastFedralTableApi();
    }, []);

    const columnsLastFedral = useMemo(() => [
        {
            title: 'Inspection',
            dataIndex: 'name',
            key: 'name',
            width: 220,
            render: (text, record) => record?.InspName || 'N/A'
        },
        {
            title: 'Last Date',
            dataIndex: 'age',
            key: 'age',
            render: (text, record) => record.LastCompleted ? moment(record.LastCompleted)?.utc().format('MM-DD-YYYY') : 'N/A'
        },
        {
            title: 'Next Date',
            dataIndex: 'age',
            key: 'age',
            render: (text, record) => {
                if (!record?.NextDueDate) return "N/A";

                const date1 = new Date(moment(record?.NextDueDate).utc().format("MM-DD-YYYY"));
                const currentDate = new Date(moment().utc().format("MM-DD-YYYY"));

                return <span
                    style={{
                        background: date1 > currentDate ? "" : "#ff000054",
                        padding: date1 > currentDate ? "" : "5px",
                        fontWeight: date1 > currentDate ? "" : "bold",

                    }}>
                    {moment(record?.NextDueDate).utc().format("MM-DD-YYYY")}
                </span>
            }
        },
    ], [])


    function isISO8601Format(dateString) {
        return moment(dateString, moment.ISO_8601, true).isValid();
    }

    const GetLocomotiveByID = async () => {

        const result = await getLocomotiveByID(state.data.id)


        if (result?.httpStatus === 200) {
            form.setFieldsValue({
                ...result?.data,
                ...result?.data?.TGSLocation,
                FRA: result?.data?.FRA,
                accounting: result?.data?.ActJob,
                status: checkStatus(result?.data?.status),
                Mfr_Year: result?.data?.Mfr_Year ? isISO8601Format(result?.data?.Mfr_Year) ? moment(result?.data?.Mfr_Year)?.format("YYYY") : "N/A" : "N/A"
            })
            setData(result?.data)
            getAllLease(result?.data)
        }
    }


    const getAllLease = async (data) => {
        const result = await getAllLocomotiveLease(data?.id)

        if (result.httpStatus === 200) {
            if (result?.data?.length) form.setFieldsValue({
                lease: result?.data?.[0]?.AutoRenew === 'YES' ? `Expire ${moment(result?.data[0].ContractEndDate).format('MM-DD-YYYY ')} (EVG) / ${result?.data[0].AgreementType} - ${formatCurrency(result?.data[0].MonthlyAmt, 'USD')}` : `Expire ${moment(result?.data[0].ContractEndDate).format('MM-DD-YYYY ')} / ${result?.data[0].AgreementType} - ${formatCurrency(result?.data[0].MonthlyAmt)}`,
            })
        }
    }
    useEffect(() => {
        GetLocomotiveByID()
    }, [openModal, notesModal, contractModal, leaseModal, equipID])


    const HandleModal = (type) => {
        if (type === 'lookup') setOpenModal(!openModal)
        else if (type === 'Notes') {
            setNotesModal(!notesModal)
        }
        else if (type === 'contract') {
            setContractModal(!contractModal)
        } else if (type === 'lease') {
            setLeaseModal(!leaseModal)

        }
    }

    const handleBackButtonClick = () => {
        // Check if the user came from /Locomotive-work-order-edit with an equipID
        if (equipID) {
            // Navigate to /Locomotive-work-order-edit with equipID
            history.push({
                pathname: "/Locomotive-work-order-edit",
                state: { equipID }
            });
        } else {
            // Perform default back navigation
            history.goBack();
        }
    };
    const handleHistoryModal = () => {
        setIsModalOpen(true);
    }
    const handleOpenWorkModal = () => {
        setModalOpenWork(true);
    }
    const handleOkOpenModal = () => {
        setModalOpenWork(false)
    }
    const showModalOpenWorkModal = () => {
        setModalOpenWork(true);
    };
    const handleCancelOpenModal = () => {
        setModalOpenWork(false)
    }

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <div style={{
                    alignItems: "center",
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Button onClick={handleBackButtonClick} style={{
                        background: 'white',
                        color: "#2863ad",
                        borderRadius: "10px",
                        marginTop: "10px"
                    }}>
                        <CaretLeftOutlined /> Back
                    </Button>
                    {Data && Data.status && Data.status.status !== "DEL" && (
                        <Button onClick={() => { history.push({ pathname: "/create-ticket", state: { type: 4, EquipId: Data.id } }) }}
                            style={{
                                background: '#2863ad',
                                color: "white",
                                borderRadius: "10px",
                                marginTop: "10px"
                            }}>
                            <PlusCircleOutlined /> Open Mechanical Ticket
                        </Button>
                    )}
                </div>
                <div style={{
                    alignItems: "center",
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row-reverse'
                }}>
                    <Button onClick={handleHistoryModal}
                        style={{
                            background: '#2863ad',
                            color: "white",
                            borderRadius: "10px",
                            marginTop: "10px",
                            // marginLeft: '10px'
                        }}>
                        <PlusCircleOutlined /> Maintenance History</Button>
                </div>
                <div style={{
                    alignItems: "center",
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row-reverse'
                }}>
                    <Button
                        style={{
                            background: '#2863ad',
                            color: "white",
                            borderRadius: "10px",
                            marginTop: "10px",
                            // marginLeft: '10px'
                        }}
                        onClick={() => setInspectionModal(true)}
                    >
                        <PlusCircleOutlined />Inspection History</Button>
                </div>
                <div style={{
                    alignItems: "center",
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row-reverse'
                }}>

                    <Button onClick={handleOpenWorkModal}
                        style={{
                            background: '#2863ad',
                            color: "white",
                            borderRadius: "10px",
                            marginTop: "10px",
                            // marginLeft: '10px'
                        }}>
                        <PlusCircleOutlined /> Open Work Orders</Button>


                </div>


                <Grid id="PageTitle">Locomotive Lookup </Grid>
                <div >
                    <Row>
                        <Col md={15}>
                            <Form style={{ marginTop: '30px', display: "flex", flexDirection: "column", gap: "5px" }}
                                name="LocomotiveForm"
                                onFinish={() => { }}
                                form={form}
                            >
                                {
                                    Fields.map((item, index) => (
                                        item?.visibility === true ?
                                            <div style={{ display: "flex", alignItems: "center", }}>
                                                <div style={{
                                                    fontWeight: "800",
                                                    whiteSpace: "nowrap",
                                                    padding: "0px",
                                                    margin: "0px",
                                                    fontSize: "13px",
                                                    display: 'flex',
                                                    overflow: 'hidden',
                                                    width: '400px',
                                                    gap: "10px",
                                                    alignItems: "center"
                                                }}>
                                                    <p style={{ marginBottom: "0px", width: "130px" }}>{item.name}</p>
                                                    {Data?.status?.status !== "DEL" && (
                                                        item?.edit && (
                                                            <Button
                                                                onClick={() => {
                                                                    if (item?.key !== 'lease') {
                                                                        setModalData({ label: item, values: Data });
                                                                        HandleModal('lookup');
                                                                    } else {
                                                                        HandleModal('lease');
                                                                    }
                                                                }}
                                                                style={{ background: "none", border: "none", marginBottom: "0px" }}
                                                            >
                                                                <EditOutlined style={{ cursor: "pointer", fontSize: '20px' }} />
                                                            </Button>
                                                        )
                                                    )}

                                                </div>
                                                <Form.Item name={item?.key} rules={[{ required: item?.required, message: ErrorMessages.requiredField }]} style={{ display: "flex", alignItems: "center", margin: "0px" }}>
                                                    {
                                                        <Input type={item?.type} placeholder='N-A' readOnly={true} style={{
                                                            background: 'none',
                                                            border: "none",
                                                            fontSize: "13px",
                                                            width: "500px"
                                                        }} />
                                                    }
                                                </Form.Item>
                                            </div> : ''
                                    ))
                                }
                                <div style={{ display: "flex", gap: "20px", marginTop: "30px" }}>
                                    <Button style={{
                                        background: '#2863ad', color: "white",
                                        width: "fit-content", borderRadius: "10px  "
                                    }} onClick={showModal}>
                                        <FileTextOutlined />Data Sheet
                                    </Button>

                                    <Button onClick={() => { HandleModal('Notes') }} style={{
                                        background: '#2863ad', color: "white",
                                        width: "fit-content", borderRadius: "10px  "
                                    }}><PlusOutlined />Notes </Button>


                                    <Button onClick={() => { HandleModal('contract') }} style={{
                                        background: '#2863ad', color: "white",
                                        width: "fit-content", borderRadius: "10px  "
                                    }}><ContactsOutlined />Contacts </Button>
                                </div>
                                {/* <div>
                                <LastFedral/>
                            </div> */}
                            </Form>
                        </Col>
                        <Col md={9} style={{ marginTop: '50px' }}>
                            <LastFedral columns={columnsLastFedral} dataSource={dataSourceLastFedral} />
                        </Col>
                    </Row>
                </div>
            </Grid>

            <DataSheetModal open={isModalEquipDataSheet} onOk={handleOk} onCancel={handleCancel} />
            <LocmotiveLookupModal open={openModal} close={HandleModal} data={modalData} setRefresh={setRefresh} />
            <NotesModal open={notesModal} close={HandleModal} data={Data} />
            <ContractModal open={contractModal} close={HandleModal} data={Data} />
            <LocomotiveLeaseModal open={leaseModal} close={HandleModal} data={Data} />
            <HistoryModal visible={isModalOpen} closeModal={() => setIsModalOpen(false)} />
            <InspectionModal inspectionModal={inspectionModal} setInspectionModal={setInspectionModal} locomotiveID={newEquip} refresh={refresh} setRefresh={setRefresh} />
            <OpenWorkOrderModal visible={ModalOpenWork} handleOk={handleOkOpenModal} handleCancel={handleCancelOpenModal} showModal={showModalOpenWorkModal} stateData={stateData} /> 
        </PageLayout>
    )
}

export default LocomotiveEdit